import { createStandardAction } from "typesafe-actions";

export const setEditbutton = createStandardAction("@@utils/SET_EDITBUTTON")();